"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCore = void 0;
const indent_1 = require("../../utils/indent");
const Cores = __importStar(require("../core"));
const isIdentifier_1 = require("../utils/isIdentifier");
function formatCore(core) {
    switch (core["@kind"]) {
        case "Var": {
            return core.name;
        }
        case "PatternVar": {
            return "?" + core.name;
        }
        case "Pi":
        case "PiImplicit": {
            const { bindings, retType } = Cores.unfoldFormatPi(core);
            return `${formatArgs(bindings)} -> ${retType}`;
        }
        case "Fn":
        case "FnImplicit": {
            const { bindings, ret } = Cores.unfoldFormatFn(core);
            return `${formatArgs(bindings)} => ${ret}`;
        }
        case "Ap":
        case "ApImplicit": {
            const { target, args } = Cores.unfoldFormatAp(core);
            return `${target}${formatArgs(args)}`;
        }
        case "Sigma": {
            if (Cores.freeOccurred(core.name, core.cdrType)) {
                const { bindings, cdrType } = Cores.unfoldFormatSigma(core);
                return `exists ${formatArgs(bindings)} ${cdrType}`;
            }
            else {
                const args = formatArgs([
                    formatCore(core.carType),
                    formatCore(core.cdrType),
                ]);
                return `Pair${args}`;
            }
        }
        case "Cons": {
            const args = formatArgs([formatCore(core.car), formatCore(core.cdr)]);
            return `cons${args}`;
        }
        case "Car": {
            const args = formatArgs([formatCore(core.target)]);
            return `car${args}`;
        }
        case "Cdr": {
            const args = formatArgs([formatCore(core.target)]);
            return `cdr${args}`;
        }
        case "Quote": {
            return `"${core.data}"`;
        }
        case "ClazzNull":
        case "ClazzCons":
        case "ClazzFulfilled": {
            const { bindings } = Cores.unfoldFormatClazz(core);
            return core.name
                ? `class ${core.name} {\n${(0, indent_1.indent)(bindings.join("\n"))}\n}`
                : `class {\n${(0, indent_1.indent)(bindings.join("\n"))}\n}`;
        }
        case "Objekt": {
            const properties = Object.entries(core.properties).map(([name, property]) => (0, isIdentifier_1.isIdentifier)(name)
                ? `${name}: ${formatCore(property)}`
                : `"${name}": ${formatCore(property)}`);
            return `{\n${(0, indent_1.indent)(properties.join(",\n"))}\n}`;
        }
        case "Dot": {
            return `${formatCore(core.target)}.${core.name}`;
        }
        case "Replace": {
            const target = formatCore(core.target);
            const motive = formatCore(core.motive);
            const base = formatCore(core.base);
            const args = formatArgs([target, motive, base]);
            return `replace${args}`;
        }
    }
}
exports.formatCore = formatCore;
function isLargeArgs(args) {
    return args.some((arg) => arg.includes("\n")) || args.join(", ").length >= 60;
}
function formatArgs(args) {
    if (isLargeArgs(args)) {
        return `(\n${args.map((arg) => (0, indent_1.indent)(arg) + ",").join("\n")}\n)`;
    }
    else {
        return `(${args.join(", ")})`;
    }
}
//# sourceMappingURL=formatCore.js.map